angular.module('iconoglobe')
.directive('windowresize', ['$window', '$rootScope', function ($window, $rootScope) {
	return {
		link: link,
		restrict: 'A'            
	};
	function link(scope, element, attrs){
		scope.resize = function(){
			$rootScope.$emit('windowResized');
		}
		angular.element($window).bind('resize', scope.resize);
		element.on('$destroy', function(){
			angular.element($window).unbind('resize', scope.resize);
		});  
	}    
 }]);